module.exports = __webpack_public_path__ + "media/images/image_gwic-fd4809d6a4aca35dd8b8478d4a27f233.png";